import { getEventPinConfig, getPlacePinConfig } from '../../lib/pinConfig.js'

export default function CategoryFilterBar({
    categoryOptions,
    activeCategoryKeys,
    hasActiveFilters,
    onToggleCategory,
    onClearCategories,
}) {
    if (!Array.isArray(categoryOptions) || categoryOptions.length === 0) {
        return null
    }

    const activeSet = new Set(activeCategoryKeys ?? [])

    return (
        <div className="border-t border-purple-100 px-4 py-3">
            <div className="mb-3 flex items-center justify-between gap-3">
                <p className="text-sm font-semibold text-slate-700">Filter by category</p>
                {hasActiveFilters && (
                    <button
                        type="button"
                        onClick={onClearCategories}
                        className="text-xs font-semibold text-logo-pink transition hover:text-purple-600"
                    >
                        Clear filters
                    </button>
                )}
            </div>
            <div className="flex flex-wrap gap-3">
                {categoryOptions.map(option => {
                    const isActive = activeSet.has(option.key)
                    const pinConfig = option.type === 'places'
                        ? getPlacePinConfig(option.label)
                        : getEventPinConfig(option.label)
                    return (
                        <button
                            key={option.key}
                            type="button"
                            onClick={() => onToggleCategory?.(option.key)}
                            className={`flex w-20 flex-col items-center gap-2 rounded-2xl border border-transparent p-2 text-center text-xs font-medium transition focus:outline-none focus-visible:ring-2 focus-visible:ring-purple-400 ${
                                isActive ? 'bg-purple-50 text-purple-700' : 'text-slate-600 hover:bg-slate-50'
                            }`}
                        >
                            <span
                                className={`flex h-12 w-12 items-center justify-center rounded-full border-2 text-xl transition ${
                                    isActive ? 'shadow-md' : 'shadow-sm'
                                }`}
                                style={{
                                    backgroundColor: pinConfig.background,
                                    borderColor: pinConfig.borderColor,
                                    color: pinConfig.glyphColor,
                                }}
                            >
                                {pinConfig.glyph}
                            </span>
                            <span className="leading-tight">{option.label}</span>
                        </button>
                    )
                })}
            </div>
        </div>
    )
}
